export interface MangaItem {
  id: number;
  title: string;
  originalTitle: string;
  author: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  tags: string[];
  rating: number;
  status: '连载中' | '已完结';
  chapters: number;
  views: number;
  description: string;
  featured: boolean;
  updatedAt: string;
  publishedAt: string;
}

export const mangaList: MangaItem[] = [
  {
    id: 1,
    title: '剑风传奇',
    originalTitle: 'ベルセルク',
    author: '三浦建太郎',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20art%20style%20with%20a%20lone%20warrior%20holding%20a%20massive%20sword%20in%20a%20gothic%20medieval%20setting%2C%20dramatic%20lighting%2C%20detailed%20line%20art%2C%20manga%20cover%20aesthetic%2C%20dark%20atmosphere%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-01&orientation=portrait',
    category: '青年漫画',
    categorySlug: 'seinen',
    tags: ['黑暗奇幻', '史诗', '复仇'],
    rating: 9.8,
    status: '连载中',
    chapters: 374,
    views: 25800000,
    description: '故事背景设定在一个类似欧洲中世纪的奇幻世界，讲述了孤独的剑士格斯在复仇之路上的黑暗冒险。这部作品以其宏大的世界观、深刻的人物塑造和震撼的画面表现力而闻名于世，被誉为黑暗奇幻漫画的巅峰之作。',
    featured: true,
    updatedAt: '2026-08-04',
    publishedAt: '1989-10-01',
  },
  {
    id: 2,
    title: '海贼王',
    originalTitle: 'ONE PIECE',
    author: '尾田荣一郎',
    coverImage: 'https://readdy.ai/api/search-image?query=Vibrant%20adventure%20manga%20art%20with%20a%20young%20pirate%20boy%20wearing%20a%20straw%20hat%20on%20a%20ship%20at%20sea%2C%20colorful%20dynamic%20composition%2C%20manga%20cover%20style%2C%20bright%20and%20energetic%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-02&orientation=portrait',
    category: '少年漫画',
    categorySlug: 'shonen',
    tags: ['冒险', '友情', '热血'],
    rating: 9.7,
    status: '连载中',
    chapters: 1120,
    views: 52000000,
    description: '拥有财富、名声、权力，这世界上的一切的男人——海贼王哥尔·D·罗杰，在被行刑受死之前说了一句话，让全世界的人都涌向了大海。「想要我的宝藏吗？如果想要的话，那就到海上去找吧，我全部都放在那里。」世界开始迎接大海贼时代的来临！',
    featured: true,
    updatedAt: '2026-08-03',
    publishedAt: '1997-07-22',
  },
  {
    id: 3,
    title: '咒术回战',
    originalTitle: '呪術廻戦',
    author: '芥见下下',
    coverImage: 'https://readdy.ai/api/search-image?query=Supernatural%20action%20manga%20art%20with%20a%20teenage%20boy%20with%20spiky%20hair%20surrounded%20by%20cursed%20energy%20effects%2C%20dark%20urban%20fantasy%2C%20dynamic%20fighting%20pose%2C%20manga%20cover%20aesthetic%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-03&orientation=portrait',
    category: '少年漫画',
    categorySlug: 'shonen',
    tags: ['战斗', '咒术', '校园'],
    rating: 9.5,
    status: '连载中',
    chapters: 268,
    views: 35000000,
    description: '虎杖悠仁是一位体育万能的高中生，某天他为了从咒物危机中解救学长姐，吞下了宿傩的手指，让咒灵「宿傩」与自己合而为一。之后他加入了专门对付咒灵的组织「东京都立咒术高等专门学校」，展开了一段惊心动魄的冒险。',
    featured: true,
    updatedAt: '2026-08-02',
    publishedAt: '2018-03-05',
  },
  {
    id: 4,
    title: '鬼灭之刃',
    originalTitle: '鬼滅の刃',
    author: '吾峠呼世晴',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20demon%20slayer%20manga%20art%20with%20a%20young%20boy%20holding%20a%20katana%20with%20water%20breathing%20effects%2C%20traditional%20Japanese%20aesthetic%2C%20manga%20cover%20style%2C%20dramatic%20composition%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-04&orientation=portrait',
    category: '少年漫画',
    categorySlug: 'shonen',
    tags: ['战斗', '和风', '感人'],
    rating: 9.6,
    status: '已完结',
    chapters: 205,
    views: 48000000,
    description: '时值日本大正时期，卖炭少年炭治郎一家被鬼所杀，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复成人类的方法，炭治郎踏上了成为鬼杀队剑士的道路。这是一部关于羁绊与希望的和风战斗物语。',
    featured: true,
    updatedAt: '2020-05-18',
    publishedAt: '2016-02-15',
  },
  {
    id: 5,
    title: '葬送的芙莉莲',
    originalTitle: '葬送のフリーレン',
    author: '山田钟人',
    coverImage: 'https://readdy.ai/api/search-image?query=Fantasy%20manga%20art%20with%20an%20elf%20girl%20mage%20with%20white%20hair%20walking%20through%20a%20beautiful%20meadow%2C%20melancholy%20atmosphere%2C%20soft%20watercolor%20style%2C%20manga%20cover%20aesthetic%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-05&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    tags: ['奇幻', '治愈', '冒险'],
    rating: 9.7,
    status: '连载中',
    chapters: 138,
    views: 18000000,
    description: '打倒魔王的勇者一行人中的魔法使——精灵族的芙莉莲，在勇者逝世后踏上了「了解人类」的旅途。这是一部讲述时间、生命与羁绊的奇幻物语，让人在阅读中感受到深深的温暖与感动。',
    featured: true,
    updatedAt: '2026-08-01',
    publishedAt: '2020-04-28',
  },
  {
    id: 6,
    title: '进击的巨人',
    originalTitle: '進撃の巨人',
    author: '谏山创',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20action%20manga%20art%20with%20giant%20humanoid%20creatures%20and%20soldiers%20flying%20with%20gear%2C%20apocalyptic%20atmosphere%2C%20intense%20dramatic%20composition%2C%20manga%20cover%20style%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-06&orientation=portrait',
    category: '青年漫画',
    categorySlug: 'seinen',
    tags: ['黑暗', '战斗', '悬疑'],
    rating: 9.5,
    status: '已完结',
    chapters: 139,
    views: 42000000,
    description: '人类为了对抗巨人而建造了三层巨大的城墙，在长达100年的和平之后，超大型巨人的出现打破了宁静。艾伦·耶格尔亲眼目睹母亲被巨人吞噬，立誓要杀光所有巨人，由此踏上了充满绝望与希望的战斗之路。',
    featured: false,
    updatedAt: '2021-04-09',
    publishedAt: '2009-09-09',
  },
  {
    id: 7,
    title: '间谍过家家',
    originalTitle: 'SPY×FAMILY',
    author: '远藤达哉',
    coverImage: 'https://readdy.ai/api/search-image?query=Comedy%20spy%20manga%20art%20with%20a%20family%20of%20three%20in%20formal%20attire%20posing%20elegantly%2C%20one%20holding%20a%20gun%2C%20fun%20and%20stylish%2C%20manga%20cover%20aesthetic%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-07&orientation=portrait',
    category: '恋爱喜剧',
    categorySlug: 'comedy',
    tags: ['间谍', '家庭', '搞笑'],
    rating: 9.4,
    status: '连载中',
    chapters: 102,
    views: 22000000,
    description: '为了执行任务，顶级间谍「黄昏」需要在一周内组建一个临时家庭。他收养了能读心的超能力少女阿尼亚，并与职业杀手约尔假结婚。三人各怀秘密，却组成了一个充满欢笑与温情的「虚假」家庭。',
    featured: true,
    updatedAt: '2026-08-05',
    publishedAt: '2019-03-25',
  },
  {
    id: 8,
    title: '王者天下',
    originalTitle: 'キングダム',
    author: '原泰久',
    coverImage: 'https://readdy.ai/api/search-image?query=Historical%20war%20manga%20art%20with%20a%20young%20warrior%20leading%20an%20army%20in%20ancient%20China%2C%20epic%20battle%20scene%2C%20grand%20scale%2C%20manga%20cover%20style%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-08&orientation=portrait',
    category: '历史战国',
    categorySlug: 'history',
    tags: ['历史', '战争', '热血'],
    rating: 9.3,
    status: '连载中',
    chapters: 810,
    views: 15000000,
    description: '以中国战国时代为舞台，讲述少年信与秦王嬴政并肩作战，立志成为天下大将军的壮阔史诗。作品以宏大的战争场面和深刻的人物刻画著称，是一部气势磅礴的历史漫画巨作。',
    featured: false,
    updatedAt: '2026-07-30',
    publishedAt: '2006-01-26',
  },
  {
    id: 9,
    title: '排球少年!!',
    originalTitle: 'ハイキュー!!',
    author: '古馆春一',
    coverImage: 'https://readdy.ai/api/search-image?query=Sports%20manga%20art%20with%20a%20volleyball%20player%20jumping%20high%20to%20spike%20the%20ball%2C%20dynamic%20action%2C%20energetic%20atmosphere%2C%20manga%20cover%20aesthetic%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-09&orientation=portrait',
    category: '运动竞技',
    categorySlug: 'sports',
    tags: ['排球', '热血', '青春'],
    rating: 9.6,
    status: '已完结',
    chapters: 402,
    views: 25000000,
    description: '身材矮小的日向翔阳在初中时被排球部的王牌球员影山飞雄彻底击败，立志要在高中向影山复仇。然而两人却进入了同一所高中的排球部，从此展开了热血沸腾的排球青春物语。',
    featured: false,
    updatedAt: '2020-07-20',
    publishedAt: '2012-02-20',
  },
  {
    id: 10,
    title: '电锯人',
    originalTitle: 'チェンソーマン',
    author: '藤本树',
    coverImage: 'https://readdy.ai/api/search-image?query=Crazy%20action%20manga%20art%20with%20a%20boy%20with%20chainsaw%20arms%20and%20head%20in%20a%20chaotic%20urban%20setting%2C%20wild%20and%20energetic%2C%20manga%20cover%20style%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-10&orientation=portrait',
    category: '少年漫画',
    categorySlug: 'shonen',
    tags: ['黑暗', '战斗', '独特'],
    rating: 9.2,
    status: '连载中',
    chapters: 182,
    views: 30000000,
    description: '贫苦少年淀治为了偿还亡父的债务，与恶魔啵奇塔合作狩猎恶魔。在一次被黑帮背叛后濒死之际，啵奇塔与淀治合为一体，使他获得了变身成电锯人的能力。从此淀治加入了公安对魔特异4课，展开了一段疯狂而自由的生活。',
    featured: false,
    updatedAt: '2026-07-28',
    publishedAt: '2018-12-03',
  },
  {
    id: 11,
    title: '蓝色时期',
    originalTitle: 'ブルーピリオド',
    author: '山口飞翔',
    coverImage: 'https://readdy.ai/api/search-image?query=Art%20school%20manga%20style%20with%20a%20boy%20painting%20on%20canvas%20in%20a%20studio%2C%20beautiful%20color%20palette%2C%20inspiring%20atmosphere%2C%20manga%20cover%20aesthetic%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-11&orientation=portrait',
    category: '日常治愈',
    categorySlug: 'slice-of-life',
    tags: ['艺术', '青春', '励志'],
    rating: 9.3,
    status: '连载中',
    chapters: 70,
    views: 8000000,
    description: '成绩优秀但内心空虚的高中生矢口八虎，在一次美术课上被一幅画深深打动，从此踏上了追求美术之路。以东京艺术大学为目标，八虎在艺术的世界中寻找真正的自我，是一部关于青春与梦想的励志故事。',
    featured: false,
    updatedAt: '2026-07-25',
    publishedAt: '2017-06-24',
  },
  {
    id: 12,
    title: '黄金神威',
    originalTitle: 'ゴールデンカムイ',
    author: '野田悟',
    coverImage: 'https://readdy.ai/api/search-image?query=Historical%20adventure%20manga%20art%20with%20a%20soldier%20and%20an%20Ainu%20girl%20in%20Hokkaido%20wilderness%2C%20gold%20rush%20theme%2C%20manga%20cover%20style%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-12&orientation=portrait',
    category: '历史战国',
    categorySlug: 'history',
    tags: ['冒险', '历史', '美食'],
    rating: 9.4,
    status: '已完结',
    chapters: 314,
    views: 12000000,
    description: '日俄战争英雄「不死之身杉元」为了治好战友遗孀的眼疾，前往北海道寻找传说中的黄金。在那里他遇到了阿伊努族少女阿席莉帕，两人一同踏上了充满冒险、美食与文化的寻金之旅。',
    featured: false,
    updatedAt: '2022-04-28',
    publishedAt: '2014-08-21',
  },
  {
    id: 13,
    title: '约定的梦幻岛',
    originalTitle: '約束のネバーランド',
    author: '白井海芋',
    coverImage: 'https://readdy.ai/api/search-image?query=Suspense%20manga%20art%20with%20children%20escaping%20from%20an%20orphanage%20at%20night%2C%20mysterious%20and%20tense%20atmosphere%2C%20manga%20cover%20aesthetic%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-13&orientation=portrait',
    category: '悬疑推理',
    categorySlug: 'mystery',
    tags: ['悬疑', '逃脱', '智斗'],
    rating: 9.1,
    status: '已完结',
    chapters: 181,
    views: 20000000,
    description: '在孤儿院「Grace Field House」中，孩子们过着幸福的生活。直到艾玛和诺曼发现了可怕的真相——他们只是鬼的食物。为了生存，孩子们策划了一场惊心动魄的大逃亡。',
    featured: false,
    updatedAt: '2020-06-15',
    publishedAt: '2016-08-01',
  },
  {
    id: 14,
    title: '黑执事',
    originalTitle: '黒執事',
    author: '枢梁',
    coverImage: 'https://readdy.ai/api/search-image?query=Gothic%20manga%20art%20with%20a%20young%20noble%20boy%20and%20his%20elegant%20butler%20in%20Victorian%20era%20setting%2C%20dark%20and%2C%20sophisticated%2C%20manga%20cover%20aesthetic%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-14&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    tags: ['哥特', '悬疑', '华丽'],
    rating: 9.0,
    status: '连载中',
    chapters: 208,
    views: 16000000,
    description: '19世纪的英国，名门贵族凡多姆海伍家的年轻当家夏尔，与执事塞巴斯蒂安·米卡利斯订下了契约。塞巴斯蒂安是恶魔，他完美地处理着夏尔的一切事务，只为了在契约完成时得到夏尔的灵魂。',
    featured: false,
    updatedAt: '2026-07-20',
    publishedAt: '2006-09-16',
  },
  {
    id: 15,
    title: '蓝色监狱',
    originalTitle: 'ブルーロック',
    author: '金城宗幸',
    coverImage: 'https://readdy.ai/api/search-image?query=Intense%20soccer%20manga%20art%20with%20a%20striker%20with%20fierce%20eyes%20about%20to%20score%20a%20goal%2C%20dramatic%20lighting%2C%20manga%20cover%20style%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-15&orientation=portrait',
    category: '运动竞技',
    categorySlug: 'sports',
    tags: ['足球', '竞技', '生存'],
    rating: 9.3,
    status: '连载中',
    chapters: 280,
    views: 17000000,
    description: '日本足球联盟为了培养世界第一的前锋，启动了「蓝色监狱」计划。300名高中生前锋被关入封闭设施，通过残酷的淘汰赛制争夺唯一的生存名额。这是一部关于足球与自我超越的激燃竞技漫画。',
    featured: false,
    updatedAt: '2026-08-04',
    publishedAt: '2018-08-01',
  },
  {
    id: 16,
    title: '更衣人偶坠入爱河',
    originalTitle: 'その着せ替え人形は恋をする',
    author: '福田晋一',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20manga%20art%20with%20a%20cosplay%20girl%20and%20a%20quiet%20boy%20in%20a%20school%20setting%2C%20sweet%20and%20colorful%2C%20manga%20cover%20aesthetic%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-16&orientation=portrait',
    category: '恋爱喜剧',
    categorySlug: 'comedy',
    tags: ['恋爱', 'cosplay', '校园'],
    rating: 9.2,
    status: '连载中',
    chapters: 107,
    views: 14000000,
    description: '梦想成为人偶工匠的男高中生五条新菜，与喜爱cosplay的辣妹喜多川海梦相遇。新菜凭借精湛的裁缝技术帮助海梦制作cosplay服装，两人在相处中逐渐缩短距离，展开了一段甜蜜又搞笑的青春恋爱喜剧。',
    featured: false,
    updatedAt: '2026-07-31',
    publishedAt: '2018-01-19',
  },
  {
    id: 17,
    title: '死神',
    originalTitle: 'BLEACH',
    author: '久保带人',
    coverImage: 'https://readdy.ai/api/search-image?query=Cool%20action%20manga%20art%20with%20a%20boy%20holding%20a%20giant%20katana%20in%20black%20shinigami%20robe%2C%20stylish%20and%20dynamic%2C%20manga%20cover%20aesthetic%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-17&orientation=portrait',
    category: '少年漫画',
    categorySlug: 'shonen',
    tags: ['死神', '战斗', '经典'],
    rating: 9.0,
    status: '已完结',
    chapters: 686,
    views: 38000000,
    description: '高中生黑崎一护天生能看见灵体，某天他遇到了死神朽木露琪亚，并在危急关头获得了死神之力。从此一护作为代理死神，踏上了保护现世与尸魂界的战斗之旅。',
    featured: false,
    updatedAt: '2016-08-22',
    publishedAt: '2001-08-07',
  },
  {
    id: 18,
    title: '怪兽8号',
    originalTitle: '怪獣8号',
    author: '松本直也',
    coverImage: 'https://readdy.ai/api/search-image?query=Sci-fi%20monster%20manga%20art%20with%20a%20man%20transforming%20into%20a%20kaiju%20with%20glowing%20blue%20energy%2C%20dynamic%20action%2C%20manga%20cover%20style%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-18&orientation=portrait',
    category: '科幻未来',
    categorySlug: 'sci-fi',
    tags: ['怪兽', '战斗', '科幻'],
    rating: 9.1,
    status: '连载中',
    chapters: 115,
    views: 13000000,
    description: '在怪兽频繁出现的日本，32岁的大叔日比野卡夫卡梦想加入防卫队却屡次失败。某天他意外获得了变成怪兽的能力，被称为「怪兽8号」。在隐藏身份的同时，他重新朝防卫队的梦想前进。',
    featured: false,
    updatedAt: '2026-08-03',
    publishedAt: '2020-07-03',
  },
  {
    id: 19,
    title: '迷宫饭',
    originalTitle: 'ダンジョン飯',
    author: '九井谅子',
    coverImage: 'https://readdy.ai/api/search-image?query=Fantasy%20cooking%20manga%20art%20with%20adventurers%20cooking%20monsters%20in%20a%20dungeon%2C%20delicious%20food%20and%20fun%20atmosphere%2C%20manga%20cover%20aesthetic%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-19&orientation=portrait',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    tags: ['美食', '冒险', '搞笑'],
    rating: 9.4,
    status: '已完结',
    chapters: 97,
    views: 10000000,
    description: '在迷宫深处，冒险者莱欧斯的妹妹被炎龙吞食。为了在妹妹被消化前救出她，莱欧斯决定不再返回地面补给，而是在迷宫中狩猎怪物并烹饪食用。一部将美食与冒险完美融合的独特奇幻漫画。',
    featured: false,
    updatedAt: '2023-09-15',
    publishedAt: '2014-02-06',
  },
  {
    id: 20,
    title: '章鱼噼的原罪',
    originalTitle: 'タコピーの原罪',
    author: 'タイザン5',
    coverImage: 'https://readdy.ai/api/search-image?query=Emotional%20manga%20art%20with%20a%20cute%20octopus-like%20alien%20and%20a%20sad%20school%20girl%2C%20touching%20and%20melancholy%20atmosphere%2C%20manga%20cover%20aesthetic%2C%20professional%20illustration&width=600&height=850&seq=manga-cover-20&orientation=portrait',
    category: '日常治愈',
    categorySlug: 'slice-of-life',
    tags: ['治愈', '校园', '感人'],
    rating: 9.0,
    status: '已完结',
    chapters: 16,
    views: 6000000,
    description: '来自快乐星球的章鱼型外星人「章鱼噼」来到地球，遇到了被欺凌的小学生久世静香。章鱼噼用外星道具试图帮助静香获得幸福，却不断引发意想不到的连锁反应。一部令人心碎又温暖的短篇佳作。',
    featured: false,
    updatedAt: '2022-03-25',
    publishedAt: '2021-12-10',
  },
];

export const featuredMangaIds = [1, 2, 3, 4, 5, 7];

export const latestMangaIds = [7, 1, 15, 18, 2, 3, 16, 5];